<template>
    <div class="breadBox">
        <Breadcrumb separator="<b class='breadcrumb-separator'>></b>">
            <BreadcrumbItem :to="item.meta.path" v-for="(item,index) in levelList" :key="index">{{item.name}}</BreadcrumbItem>
        </Breadcrumb>
    </div>
</template>

<script>
export default {
    data(){
        return{
            routerArray:[],
            levelList:[]
        }
    },
    watch:{
        $route (to, from) {
            this.getBreadcrumb()
        }
    },
    methods:{
        getBreadcrumb(){
            let matched=this.$route.matched.filter(item=>item.name);
            matched[0].path="/"
            const first=matched[0];
            // debugger
            if(first && first.meta.parentId !==0){
                matched=[{ path: '/', meta: { title: '首页' }}].concat(matched);
            }
            this.levelList=matched;
        }
    },
    mounted(){
        this.getBreadcrumb()
    }
}
</script>

<style lang="scss" scoped>
    .breadBox{
        height: 50px;
        line-height: 50px;
        text-indent: 20px;
        border-bottom: 1px solid #dddddd;
        // overflow: hidden;
        // background: #dddddd;
        .breadcrumb-separator{
            color: gray;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/Bread/ItBread.vue